/**
 * ドラッグ禁止
 */
export class DrugControl {
  constructor() {
    this.init();
  }
  init() {
    document.onselectstart = function(){ return false; };
    document.onmousedown = function(){ return false; };
    document.body.onselectstart = "return false;"
    document.body.onmousedown = "return false;"
  }
}
